import React from 'react'
import styles from './divider.module.css'

const Divider = ({ className = ''}) => {
  return (
    <div className={`${styles.divider} ${className}`}></div>
  )
}

export default Divider